import 'firebase/database';
import { Family } from '@interfaces/index';
import firebase from 'gatsby-plugin-firebase';
import { useListVals } from 'react-firebase-hooks/database';

export const useFamilies = () => {
  const [families, loading, error] = useListVals<Family>(
    firebase
      .database()
      .ref('/restaurants/d-vero/families')
      .orderByChild('order'),
    {
      keyField: 'uuid'
    }
  );
  return {
    families,
    loading,
    error,
  };
};
